import React, { useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { Panel } from '@plerionhq/design-system';
import './Pricing.css';
import { tierList } from './tierList';
import { PricingComponent } from './PricingComponent';

import { useTranslation } from 'react-i18next';

export const PricingCalculator = () => {
  const { t } = useTranslation('containerInterface');
  const [cloudResource, cloudResourceSet] = useState(0);
  const [cloudEvents, cloudEventsSet] = useState(0);
  const [workloadScans, workloadScansSet] = useState(0);
  const [lakeData, lakeDataSet] = useState(0);

  const plerionUnits = Math.ceil(
    cloudResource + workloadScans * 2 + lakeData + cloudEvents / 1000,
  );

  const tier = tierList(t).find((tier) => {
    return plerionUnits >= tier.minUnits && plerionUnits <= tier.maxUnits;
  });
  return (
    <div className="flex h-screen max-h-[calc(100vh-48px)] flex-col items-center overflow-auto py-10">
      <Panel className="mx-auto w-full max-w-[1200px]">
        <div className="flex flex-wrap lg:flex-nowrap">
          <div className="flex flex-grow flex-col gap-y-5 p-4 px-5">
            <h1 className="text-br-primary flex flex-col-reverse text-3xl leading-tight font-semibold sm:flex-row">
              <div>
                {t('plerionPricing')}
                <p className="mt-1 text-base font-normal text-gray-700">
                  {t('useThisPricingCalculatorToFindThe')}
                </p>
              </div>
              <div className="bg-br-primary/10 text-br-primary flex-shrink-0 self-center rounded-lg p-3 lg:ml-auto">
                <CurrencyDollarIcon className="h-8 w-8" />
              </div>
            </h1>

            <PricingComponent
              maxRange={10000}
              step={100}
              value={cloudResource}
              setValue={cloudResourceSet}
              title={t('cloudSecurityPostureManagementCspm')}
              description={t('cspmUnitConsumptionIsBasedOnThe')}
              unitDescription={t('oneCloudResourceEquatesToOnePlerionUnit')}
            />
            <PricingComponent
              maxRange={10000}
              step={100}
              value={workloadScans}
              setValue={workloadScansSet}
              title={t('cloudWorkloadProtectionPlatformCwpp')}
              unitDescription={t('oneWorkloadScanEquateToTwoPlerionUnits')}
              description={t('cwppUnitConsumptionIsBasedOnThe')}
            />
            <PricingComponent
              maxRange={10000000}
              step={10000}
              value={cloudEvents}
              setValue={cloudEventsSet}
              title={t('cloudDetectionAndResponseCdr')}
              unitDescription={t('thousandCloudEventsEquateToOnePlerionUnit')}
              description={t('cdrUnitConsumptionIsBasedOnThe')}
            />
            <PricingComponent
              maxRange={10000}
              step={100}
              value={lakeData}
              setValue={lakeDataSet}
              title={t('dataLake')}
              description={t('amountOfDataProcessedByPlerion')}
              unitDescription={t('oneGbDataProcessedEquatesToOnePlerionUnit')}
            />
          </div>
          <div className="flex w-[450px] flex-col overflow-hidden rounded-r text-white">
            <h2 className="bg-br-primary flex w-full flex-col items-center p-4 text-lg font-medium text-gray-100">
              <span>{t('estimatedPlerionUnits')}</span>
              <span className="font-semibold">
                <NumericFormat
                  displayType="text"
                  thousandSeparator={true}
                  value={plerionUnits}
                />{' '}
              </span>
            </h2>
            <div className="bg-br-primary/95 flex flex-grow flex-col items-center gap-4 px-4 py-4 pt-20">
              <div className="text-xl leading-tight text-gray-300">
                {t('recommendedPlan')}
              </div>
              <div className="text-center text-4xl leading-tight font-semibold">
                {tier?.name}
              </div>
              <div className="text-3xl leading-tight font-semibold text-gray-50">
                {tier?.pricing}
              </div>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};
